export const SEND_EMAIL = 'SEND_EMAIL';
export const ERROR_EMAIL = 'ERROR_EMAIL';
export const SET_LOADING = 'SET_LOADING';
export const SET_DATA_CONTEXT_ANO = 'SET_DATA_CONTEXT_ANO';